import { render } from "./BrandSafetySegments.vue?vue&type=template&id=7eaf1874&scoped=true"
import script from "./BrandSafetySegments.vue?vue&type=script&lang=js"
export * from "./BrandSafetySegments.vue?vue&type=script&lang=js"

import "./BrandSafetySegments.vue?vue&type=style&index=0&id=7eaf1874&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eaf1874"]])

export default __exports__